import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

class UserEngagement extends Component {

    render() {
        return (
            <div className="col-lg-12" style={{ marginLeft: "20px" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <ToastContainer className="Toast-at-center" />

                <div class="row mt-4 mb-4">
                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", borderRadius: "9px"
                    }}>
                        <br />Number Of<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfTotalUserChat}{this.props.value.totalUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#93D2FA",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of Unique<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfUniqueUserChat}{this.props.value.uniqueUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>

                    <div style={{
                        width: "150px", height: "150px", backgroundColor: "#B7E1FC",
                        paddingLeft: "10px", fontSize: "13px", marginLeft: "9px", borderRadius: "9px"
                    }}>
                        <br />Number Of Anonymous<br />Users<br /><br />
                        <div style={{ fontSize: "30px", textAlign: "Right", paddingRight: "10px" }}>{this.props.value.noOfAnonymousUserChat}{this.props.value.anonymousUserChatScaleType}<br />
                            <div style={{ fontSize: "10px" }}>All Time</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default UserEngagement;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/conversationStat/UserEngagement.js